import Tag from './tag'
export * from './tag'
export default Tag
